import { CheckCircle2 } from 'lucide-react';

/**
 * Horizontal step indicator used by SendDocumentPage's multi-step wizard.
 *
 * Pure presentational — given a list of `{id, title, icon}` steps and
 * the current 0-indexed position, renders icons + connectors. Steps
 * before `currentStep` get a green check; the active step is outlined;
 * later steps are muted.
 */
export const WizardSteps = ({ steps, currentStep }) => (
  <div className="flex items-center justify-between mb-12">
    {steps.map((step, index) => (
      <div key={step.id} className="flex items-center">
        <div
          className={`flex items-center gap-3 ${
            index <= currentStep ? 'text-primary' : 'text-muted-foreground'
          }`}
        >
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-200 ${
              index < currentStep
                ? 'bg-primary text-white'
                : index === currentStep
                  ? 'bg-primary/10 text-primary border-2 border-primary'
                  : 'bg-muted text-muted-foreground'
            }`}
          >
            {index < currentStep ? (
              <CheckCircle2 className="w-5 h-5" />
            ) : (
              <step.icon className="w-5 h-5" />
            )}
          </div>
          <span className="font-medium hidden sm:block">{step.title}</span>
        </div>
        {index < steps.length - 1 && (
          <div
            className={`w-16 sm:w-24 h-0.5 mx-4 ${
              index < currentStep ? 'bg-primary' : 'bg-border'
            }`}
          />
        )}
      </div>
    ))}
  </div>
);
